import { TextField } from "@mui/material";
import React, { useState } from "react";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import FreshLeadInterface from "../../interfaces/Cook/FreshLeadInterface";
import { CookService } from "../../services/CookServices";
import CkMuiDialog from "./CkMuiDialog/CkMuiDialog";
import { CustomSnackbarTypes } from "./CustomSnackBar";

const cookService = new CookService();

interface InputProps {
  cookDetail: FreshLeadInterface;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  refresh: () => void;
}

const AddChefNoteDialogCookProfile = ({
  isOpen,
  setIsOpen,
  cookDetail,
  refresh,
}: InputProps) => {
  const [comment, setComment] = useState<string | null>(null);

  const handleSubmit = () => {
    if (comment) {
      cookService
        .addChefNote(cookDetail.cookId, { comment: comment })
        .then(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Chef Note Added Successfully",
            type: CustomSnackbarTypes.SUCCESS,
          });
        })
        .catch(() => {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Something Went Wrong",
            type: CustomSnackbarTypes.ERROR,
          });
        })
        .finally(() => {
          refresh();
          setIsOpen(false);
        });
    }
  };

  const handleCommentChange = (e: any) => {
    setComment(e.target.value);
  };

  return (
    <CkMuiDialog
      isDialogOpen={isOpen}
      setDialogOpen={setIsOpen}
      onDialogClose={() => {}}
      title={"Add Chef Note"}
      primaryLabel={"Submit"}
      primaryAction={handleSubmit}
      secondaryLabel={"Close"}
      secondaryAction={() => {
        setIsOpen(false);
      }}
      isLoading={false}
      fullWidth={true}
    >
      <TextField
        id="outlined-textarea"
        label="Chef Note"
        value={comment || ""}
        rows={4}
        fullWidth
        multiline
        onChange={handleCommentChange}
      />
    </CkMuiDialog>
  );
};

export default AddChefNoteDialogCookProfile;
